import { render, staticRenderFns } from "./PopupEditTaskTheme.vue?vue&type=template&id=5f4a94a0&scoped=true&"
import script from "./PopupEditTaskTheme.vue?vue&type=script&lang=js&"
export * from "./PopupEditTaskTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a94a0",
  null
  
)

export default component.exports